import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/money/`;

const addExpenseOptions = async (formData) => {
    return await axios.post(API_URL + 'expenseoption', formData);
};

const getExpenseOptions = async () => {
    return await axios.get(API_URL + "expenseoption");
};

const deleteExpenseOption = async (id) => {
    return await axios.delete(API_URL + "expenseoption/" + id);
};

const saveExpenseRecord = async (formData) => {
    return await axios.post(API_URL + 'expense', formData);
};

const editExpenseOption = async (id, formData) => {
    console.log("EDIT")
    return await axios.put(API_URL + "expenseoption/"+ id, formData);
};

const getExpenseRecords = async () => {
    return await axios.get(API_URL + "expense");
};

const deleteExpense = async (id) => {
    return await axios.delete(API_URL + "expense/" + id);
};

export default {
    addExpenseOptions,
    getExpenseOptions,
    deleteExpenseOption,
    saveExpenseRecord,
    getExpenseRecords,
    deleteExpense,
    editExpenseOption
};
